import React from "react";

const Footer = () => {
  return (
    <footer id="footer" className="section bg-light text-black p-0">
      <div className="mx-4">
        <div className="row my-3" style={{ color: "#AE2A2F" }}>
          <div className="col-lg-10 offset-lg-1">
            <div className="d-flex justify-content-center justify-content-md-between align-items-center gap-4">
              <div className="d-flex gap-2 align-items-center">
                <a href="https://twitter.com/bostonheart2023?s=11&t=CxfN0pM3i1catpXXLJ0IXQ" className="social-icon-link">
                  <i className="fab fa-linkedin"></i>
                </a>
                <h5 className="mb-0 d-none d-md-block">Boston Structural Heart</h5>
              </div>
              <div className="d-flex gap-2 align-items-center">
                <a href="https://www.facebook.com/people/Boston-Structural-Heart/pfbid032a63iL32iifZRiQY5TXeCrrVWeyxBFaUjzvi4qtaZZknwEM9KTSJUuqEfYpw878fl/?mibextid=LQQJ4d" className="social-icon-link">
                  <i className="fab fa-facebook-f"></i>
                </a>
                <h5 className="mb-0 d-none d-md-block">BostonStructuralHeart</h5>
              </div>
              <div className="d-flex gap-2 align-items-center">
                <a href="https://www.instagram.com/bostonstructuralheart/?igshid=YmMyMTA2M2Y%3D" className="social-icon-link">
                  <i className="fab fa-instagram"></i>
                </a>
                <h5 className="mb-0 d-none d-md-block">@BostonStructuralHeart</h5>
              </div>
            </div>
          </div>
        </div>
        <div
          className="footer-image desktop-only"></div>
        <div>
          <h3 className="text-center mt-3">Contact Us</h3>
        </div>
        <div className="d-flex flex-column flex-md-row mt-3 justify-content-md-center align-items-center gap-3 gap-md-5 mb-3">
          <div className="footer-image-harvard"></div>
          <div className="footer-image-beth"></div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
